var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeamImg4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 182,
  height: 182,
  viewBox: "0 0 182 182"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 91,
  r: 91,
  fill: "#7654fd",
  "data-name": "Ellipse 7"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#f0f0f0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.036 92.481v10.742l10.737 6.139 7.673-4.385",
  "data-name": "Path 300"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.778 109.361V98.619",
  "data-name": "Path 301"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.327 86.342 93.59 92.48l10.737 6.139 10.742-6.138Z",
  "data-name": "Path 302"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.59 92.481v10.742l10.737 6.139 10.742-6.138V92.481",
  "data-name": "Path 303"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.331 98.619v10.742",
  "data-name": "Path 304"
}), /*#__PURE__*/React.createElement("path", {
  d: "m92.05 63.324-10.738 6.137L92.05 75.6l10.747-6.139Z",
  "data-name": "Path 305"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.312 69.462v10.742l10.738 6.138 10.742-6.138V69.462",
  "data-name": "Path 306"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.054 75.6v10.738",
  "data-name": "Path 307"
}), /*#__PURE__*/React.createElement("path", {
  d: "m87.451 90.727-7.678-4.385-10.737 6.138 10.737 6.139 6.138-3.507",
  "data-name": "Path 308"
}))));
export default SvgTeamImg4;